export const DEFAULT_LOGGED_PAGE = '/home';

export const AUTH_ERROR_QUERY_KEY = 'auth_error';
export const AUTH_ERROR_QUERY_VALUE_SSO_FAILED = 'sso_failed';

export const SIGNUP_NEWSLETTER_KEY = 'signup_newsletter';
export const SIGNUP_ACCOUNT_CREATION_METHOD_KEY = 'signup_account_creation_method';
export const SIGNUP_PROVISION_PAYLOAD_KEY = 'signup_provision_payload';
export const APPLICATION_DRAFT_STORAGE_KEY = '__application_draft';

export function getUserScopedStorageKey(storageKey: string, userId: string): string {
  return `${storageKey}:${userId}`;
}

export function getSignupProvisionPayloadKey(userId: string): string {
  return getUserScopedStorageKey(SIGNUP_PROVISION_PAYLOAD_KEY, userId);
}

export function getApplicationDraftStorageKey(userId: string): string {
  return getUserScopedStorageKey(APPLICATION_DRAFT_STORAGE_KEY, userId);
}
